import { createContext, useContext, useReducer } from 'react'

const ValidationContext = createContext<any>(null)
const ValidationDispatchContext = createContext<any>(null)

type ValidationAction = {
  type: 'add' | 'delete'
  id: 'string'
}

export function WorkflowValidationsProvider({ children }: any) {
  const [validations, dispatch] = useReducer(validationsReducer, [])

  return (
    <ValidationContext.Provider value={validations}>
      <ValidationDispatchContext.Provider value={dispatch}>{children}</ValidationDispatchContext.Provider>
    </ValidationContext.Provider>
  )
}

export function useWorkflowValidations() {
  return useContext(ValidationContext)
}

export function useWorkflowValidationsDispatch() {
  return useContext(ValidationDispatchContext)
}

function validationsReducer(validations: string[], action: ValidationAction) {
  switch (action.type) {
    case 'add': {
      return [...validations, action.id]
    }
    case 'delete': {
      return validations.filter((t: any) => t !== action.id)
    }
    default: {
      throw new Error('Unknown action: ' + action.type)
    }
  }
}
